import SpriteSymbol from "../../../../dev-d21-front/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../dev-d21-front/node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "node-llm",
  "use": "node-llm-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\" id=\"node-llm\"><path fill=\"currentColor\" d=\"M18 0H2C.9 0 0 .9 0 2v18l4-4h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2m0 14H3.17L2 15.17V2h16z\" /><path fill=\"currentColor\" d=\"m10 13 1.57-3.43L15 8l-3.43-1.57L10 3 8.43 6.43 5 8l3.43 1.57z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol